﻿<script>
    import { onMount } from "svelte";
    import CreateFreeSpinCampaignModal from "../lib/components/modals/freebets/pragmatic/freespins/CreateFreeSpinCampaignModal.svelte";
    import { ICONS } from "../js/icons";
    import CampaignFilters from "../lib/components/modals/freebets/pragmatic/shared/CampaignFilters.svelte";
    import CampaignTable from "../lib/components/modals/freebets/pragmatic/shared/CampaignTable.svelte";
    import FreeSpinPlayersModal from "../lib/components/modals/freebets/pragmatic/freespins/FreeSpinPlayersModal.svelte";
    import CreateFreeChipCampaignModal from "../lib/components/modals/freebets/pragmatic/freechips/CreateFreeChipCampaignModal.svelte";
    import FreeChipPlayersModal from "../lib/components/modals/freebets/pragmatic/freechips/FreeChipPlayersModal.svelte";
    import { CampaignAPI } from "../lib/utils/freebetsApi.js";
    import backend from "../server.js";
    import { buildPragmaticCancellationParams } from "../lib/utils/pragmaticFreeSpin.js";
    import { PRAGMATIC_DEMO_CONFIG } from "../lib/config/demoClient.js";
    import { getClientFilterCodes } from '../js/credentialsApi';
    import { CAMPAIGN_STATUS } from "../lib/utils/statusEngine.js";

    const PROVIDER_CODE = "pg";

    let listRef;
    let activeList = "free-spins";
    let filters = {
        client: "",
        clientId: "",
        campaignName: "",
        statuses: [CAMPAIGN_STATUS.ACTIVE, CAMPAIGN_STATUS.SCHEDULED],
        game: "",
        currency: "",
        player: "",
        bonus: "",
        dateFrom: "",
        dateTo: "",
    };
    let selectedCampaign = null;
    let showCampaignFreeSpins = false;
    let showCreateFreeSpins = false;
    let showCreateFreeChips = false;
    let showFreeChipPlayers = false;
    let clients = [];
    let catalogsReady = false;

    const campaignApi = {
        listByProvider: CampaignAPI.listByProviderIgp,
        cancelCampaign: cancelPragmaticCampaign,
        getById: CampaignAPI.getCampaignByCampaignIdIgp,
        updateStatus: CampaignAPI.updateCampaignStatusIgp,
        updateStatusPlayer: (bonusOrId, status) => CampaignAPI.updatePlayerStatus(bonusOrId, status),
    };

    $: activeCampaignApi = activeList === "free-chips"
        ? { ...campaignApi, cancelCampaign: cancelPragmaticFreeChipCampaign }
        : campaignApi;

    const playerActions = {
        addPlayer: addPlayer,
        removePlayer: removePlayer,
    };

    function openCampaignFreeSpins(campaign) {
        const clientCode = campaign.client.clientCode;
        const clientId = clients.find(
            (item) => String(item?.code ?? item?.clientCode) === String(clientCode),
        )?.id
        selectedCampaign = campaign;
        selectedCampaign.client.clientId = clientId;
        if (campaign?.benefitType === "free-chips" || activeList === "free-chips") {
            showFreeChipPlayers = true;
        } else {
            showCampaignFreeSpins = true;
        }
    }

    function openCreateFreeSpins(event) {
        const benefitType = event?.detail?.view ?? activeList;
        selectedCampaign = null;
        if (benefitType === "free-chips") showCreateFreeChips = true;
        else showCreateFreeSpins = true;
    }

    async function cancelPragmaticCampaign(campaignId, campaign) {
        const clientCode = campaign.client.clientCode;
        const params = buildPragmaticCancellationParams(campaignId, clientCode);
        return backend.freespin.cancelFreeSpinPrg(params);
    }

    async function handlePlayersUpdated(event) {
        const { playerList } = event.detail || {};
        selectedCampaign = { ...selectedCampaign, playerList: playerList || [] };
        await listRef?.refresh?.();
    }

    function handleCampaignRefreshed(event) {
        const freshCampaign = event.detail?.doc;
        if (freshCampaign) {
            selectedCampaign = { ...selectedCampaign, ...freshCampaign };
        }
    }

    function handleFiltersChange(event) {
        filters = { ...event.detail };
    }

    async function cancelPragmaticFreeChipCampaign(campaignId, campaign) {
        const clientCode = campaign?.client?.clientCode;
        return backend.freespin.cancelFreeChipsPrg({
            clientCode,
            bonusCode: campaignId,
        });
    }

    async function removePlayer(_campaign, _player, promo = null) {
        const bonusCode = _campaign.campaignId;
        const clientCode = _campaign.client.clientCode;

        return await backend.freespin.deleteFreeSpinPrg({
            params: { id: bonusCode, bonusCode, clientCode },
            playerList: _player.playerId ? [String(_player.playerId)] : [],
        });

    }

    async function addPlayer(campaign, payload) {
        if (!Array.isArray(payload)) {
          throw new TypeError('Debe ser un array');
        }
        const params = {bonusCode: campaign.campaignId, clientCode: campaign.client.clientCode}
        if (payload.length === 0) return;

        const data = {
          playerList: payload,
        };

        if (payload.length === 1) {
            params.playerId = payload[0].playerId;
            return backend.freespin.addPlayerToCampaignPrg(params, data);
        }
        
        return await backend.freespin.addPlayersToCampaignPrg(params,data);
    }

    async function fetchClients() {
        try {
        const allowedCodes = await getClientFilterCodes();
        let params = { page: 1, xpage: 300, summary: true };

        if (allowedCodes === null) {
            // superadmin: all clients
        } else if (allowedCodes.length) {
            params.codes = allowedCodes.join(",");
        } else {
            clients = [];
            return;
        }

        const res = await backend.client.lists(params);
        const allClients = res?.data?.list || [];
        clients = allClients;

        let data = {};
        try { data = JSON.parse(sessionStorage.getItem("user") || "{}"); } catch {}
        const sessionClientId = data?.c_id ?? data?.clientId;
        if (sessionClientId) {
            clients = allClients.filter(
            (c) => String(c.id) === String(sessionClientId)
            );
        }
        } catch (err) {
        console.error("Error cargando clientes clients:", err);
        }
    }

    async function getCampaignById(campaignId) {
        const response = await CampaignAPI.getCampaignByCampaignIdIgp(campaignId);
        const campaignData =  Array.isArray(response) ? response[0] : response;
        const clientCode = campaignData.client.clientCode;
        const clientId = clients.find((item) => item.code === clientCode)?.id
        if (!campaignData.client.clientId) campaignData.client.clientId = clientId;
        return campaignData;
    }

    async function handleFreespinCreated() {
        await listRef?.refresh?.();
    }

    async function handleFreeChipCreated() {
        await listRef?.refresh?.();
    }

    async function handleFreeChipCampaignUpdated(event) {
        selectedCampaign = event.detail || selectedCampaign;
        await listRef?.refresh?.();
    }

    onMount(async () => {
        try {
            await fetchClients();
        } finally {
            catalogsReady = true;
        }
    });

</script>

{#if catalogsReady}
    <CampaignFilters
        bind:view={activeList}
        {filters}
        {clients}
        icons={ICONS}
        on:filterchange={handleFiltersChange}
        on:create={openCreateFreeSpins}
    />

    <CampaignTable
        bind:this={listRef}
        {clients}
        {filters}
        provider={PROVIDER_CODE}
        benefitType={activeList}
        api={activeCampaignApi}
        icons={ICONS}
        allowCancel={true}
        on:openplayers={(e) => openCampaignFreeSpins(e.detail)}
    />
{:else}
    <div class="campaign-list-loading" role="status">
        Cargando información de Pragmatic...
    </div>
{/if}

{#if showFreeChipPlayers && selectedCampaign}
    <FreeChipPlayersModal
        bind:show={showFreeChipPlayers}
        campaign={selectedCampaign}
        getCampaignById={getCampaignById}
        demoConfig={PRAGMATIC_DEMO_CONFIG}
        on:updated={handleFreeChipCampaignUpdated}
        on:close={() => (showFreeChipPlayers = false)}
    />
{/if}

{#if showCampaignFreeSpins}
    <FreeSpinPlayersModal
        campaign={selectedCampaign}
        actions={playerActions}
        getCampaignByCampaignId={getCampaignById}
        autoRefetchOnOpen={true}
        showExtraActions={false}
        demoConfig={PRAGMATIC_DEMO_CONFIG}
        on:close={() => (showCampaignFreeSpins = false)}
        on:playersUpdated={handlePlayersUpdated}
        on:campaignRefreshed={handleCampaignRefreshed}
    />
{/if}

<style>
    .campaign-list-loading {
        padding: 2rem;
        color: #6c757d;
        text-align: center;
    }
</style>

{#if showCreateFreeSpins}
    <CreateFreeSpinCampaignModal
        bind:showNewFreeSpin={showCreateFreeSpins}
        clients={clients}
        on:freespinCreated={handleFreespinCreated}
    />
{/if}


{#if showCreateFreeChips}
    <CreateFreeChipCampaignModal
        bind:show={showCreateFreeChips}
        {clients}
        on:created={handleFreeChipCreated}
        on:close={() => (showCreateFreeChips = false)}
    />
{/if}
